module.exports = __webpack_public_path__ + "media/images/step_03-e804ca52cb981702d4671791dd3d19ed.gif";